import { render, staticRenderFns } from "./GoldenDustMenu.vue?vue&type=template&id=6919fca9"
import script from "./GoldenDustMenu.vue?vue&type=script&lang=js"
export * from "./GoldenDustMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports